import React from "react";
import classNames from "classnames";
import styles from "./UploadFileDialog.module.scss";
import ArchivoSelecionadoImg from "../../../assets/img/upload-dialog-loaded.svg";

export const UploadFileBodySuccess = (
  {
    onReplaceFile,
    fileName
  }
) => {
  return (
    <>
      <div className={styles.BodyUploadFileSuccess}>
        <div className={classNames(styles.UploadZone, styles.UploadZoneSuccess, styles.JustifyContent)}>

          <div>
            <img id="ufbsArchivoSeleccionadoImg" src={ArchivoSelecionadoImg}
                 alt={"Archivo seleccionado"}/>
          </div>

          <div>
            <span className={styles.UploadText}>{fileName}</span>
          </div>

          <div>
            <a id="ufbsReemplazarLbl" onClick={onReplaceFile} className={styles.Link}>Reemplazar archivo</a>
          </div>

        </div>
      </div>
    </>
  );
};

export default UploadFileBodySuccess;
